import { lazy, Suspense, useContext } from "react";
import UserContext from "contexts/UserContext";
import LinearLoader from "components/Loader/LinearLoader";

function PromoHome() {
    const { loading, error, currentPromo } = useContext(UserContext);

    if (loading) {
        return <LinearLoader white={false}></LinearLoader>
    }

    if (error) {
        return <h1>{error}</h1>
    }

    if (!currentPromo) {
        return <h1>Ocorreu um erro ao acessar as promoções, tente novamente mais tarde!</h1>
    }

    const Promo = lazy(() => import(`./${currentPromo.path}/index.js`));
    return <Suspense fallback={<LinearLoader />}>
        <Promo />
    </Suspense>;
}

export default PromoHome;